export const TOOLKIT_DETAILS = {
  survey: {
    blurb: "Your personal readiness report from the 5-minute diagnostic: where you stand today, your starting route, a first project that fits your domain, and a realistic plan.",
    inside: ["Your readiness route and what it means", "A first AI project matched to your area", "A 2-week starter plan", "The course to start with (if any)"],
    time: "10 minutes", action: "Take the diagnostic, then read the route page first.",
  },
  scripts: {
    blurb: "Copy-ready scripts for LinkedIn, Naukri and recruiter outreach, written for your role and experience, so recruiters find you in search and actually reply.",
    inside: ["3 LinkedIn headline variants + About section", "Naukri headline, summary and keyword string", "Recruiter, referral and follow-up messages", "An honest 'open to work' post"],
    time: "45 minutes",
  },
  agents: {
    blurb: "Six ready-to-run AI assistants you paste into ChatGPT, Claude or Gemini. They decode job descriptions, tailor your resume, build search strings and prep you for interviews.",
    inside: ["Job-Description Decoder + Resume Tailor", "Boolean job-search strings for your profile", "Cover-note writer and application tracker", "Interview prep coach with guardrails"],
    time: "30 minutes",
  },
  maps: {
    blurb: "Five visual mind maps that turn 'learn AI' into a clear order of topics, each tailored to your role, with one thing to apply at work every week.",
    inside: ["LLM foundations → prompting → RAG", "Agents and tools → evaluation and shipping", "4 branches and 12 focus points per map", "A 'build this week' task for every map"],
    time: "20 minutes per map",
  },
  book: {
    blurb: "Key AI concepts simplified and highlighted for quick learning, so you can speak about them confidently in interviews.",
    inside: ["Core AI concepts in plain language", "Highlighted key passages", "Quick-review format"],
    time: "1-2 hours", action: "Read one highlighted chapter, then explain it out loud in 2 minutes.",
  },
  checklist: {
    blurb: "A weekly operating system for your job search, plus spoken scripts for explaining your projects, your story and any career gap or switch.",
    inside: ["'Before you apply' checklist", "A weekly search routine", "30-second and 2-minute project scripts", "Tell-me-about-yourself and career-switch answers"],
    time: "30 minutes, then weekly",
  },
  negotiation: {
    blurb: "Calm, honest scripts for the hardest panel questions and every salary moment, with why each one works and what never to say.",
    inside: ["6 tough panel questions answered", "CTC, counter-offer and notice-period scripts", "Competing-offer and closing scripts", "What never to say, for each one"],
    time: "40 minutes",
  },
};
